module.exports = __webpack_public_path__ + "img/colaboracion_msh.33f33429.jpg";